<template>
    <div v-if="isOpen" class="modal fade show" tabindex="-1" aria-labelledby="apiKeyModal" aria-hidden="true" style="display: block; background: rgba(0,0,0,0.5); z-index: 9999;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                            <h1 class="mb-0">API Key Generated</h1>
                            <button
                                @click="closeModal"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                    <div class="col-11 py-1 mx-auto">
                        <p class="text-center mt-1">Please copy this API key now. You won't be able to see it again!</p>

                        <label class="form-label mb-25">API Key <small class="text-muted">— sent as <code>X-Api-Key</code> in both directions between MiAccounts and your store</small></label>
                        <div class="input-group mb-2">
                            <input type="text" class="form-control" :value="apiKey" readonly>
                            <button class="btn btn-outline-primary" type="button" @click="copyKey">
                                <i class="fas fa-copy"></i> Copy
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false
    },
    apiKey: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['close']);
const showSuccess = inject('showSuccess');

const closeModal = () => {
    emit('close');
}

const copyToClipboard = (value, message) => {
    navigator.clipboard.writeText(value).then(() => {
        showSuccess(message);
    });
}

const copyKey = () => {
    copyToClipboard(props.apiKey, 'API key copied to clipboard!');
}
</script>
